import { env } from "@/config";

export const baseURL = {
  // Those are calling on the same domain, networx.com
  homeowner_v2: '/homeowner_api/v2',
  homeowner_v3: '/homeowner_api/v3',
  v2: '/api/v2',
  v3: '/api/v3',
  // This is calling on the api.networx.com
  api_v3: `https://${env.API_BACKEND}/v3`,
}
